import * as fromMessageAction from '../actions/messages.action';

export interface MessageState {
  messages: any;
  message: any;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  messages: null,
  message: null,
  loading: false,
  loaded: true,
  error: null,
};

export function reducer(state = initialState, action: fromMessageAction.MessagesAction): MessageState {
  switch (action.type) {
    case fromMessageAction.GET_FREELANCER_MESSAGES: {
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    }
    case fromMessageAction.GET_FREELANCER_MESSAGES_SUCCESS: {
      return {
        ...state,
        messages: action.payload.messages,
        loading: false,
        loaded: true,
      };
    }
    case fromMessageAction.GET_FREELANCER_MESSAGES_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/reducers/message.reducer.ts